import z from "zod";
import { IntegrationIdScheme } from "./ids";
import { IntegrationType } from "./enums/IntegrationType";

export const BookkeepingIntegrationSettingScheme = z.union([
  IntegrationIdScheme,
  z.literal(IntegrationType.EMAIL),
]);

export type BookkeepingIntegrationSetting = z.infer<
  typeof BookkeepingIntegrationSettingScheme
>;
